"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FirebaseWebService = void 0;
const firebase = require("firebase/app");
const _ = require("lodash");
const tables_1 = require("./constants/tables");
const helpers_1 = require("../Helpers/helpers");
class FirebaseWebService {
    constructor() {
        this.MAX_BATCH_SIZE = 500;
        this.initializeApp = () => {
            try {
                this.firebaseApp = firebase.initializeApp({
                    apiKey: "AIzaSyAbwrXprvNpPkzk-cG5R2TlIMGzmagvI8s",
                    authDomain: "mosabi-app.firebaseapp.com",
                    databaseURL: "https://mosabi-app.firebaseio.com",
                    projectId: "mosabi-app",
                    storageBucket: "mosabi-app.appspot.com",
                    messagingSenderId: "225089998612",
                    appId: "1:225089998612:web:b0fa97e7e414ea8ff73c01",
                    measurementId: "G-L8BXGD1XMS"
                });
                firebase.analytics();
            }
            catch (ex) {
                console.log("Firebase Web Service init failed", ex);
            }
        };
        this.getCurriculumByCountryIso = async (countryIso) => {
            try {
                const db = firebase.firestore();
                const snapshot = await db.collection(tables_1.Tables.CURRICULUM)
                    .where("countryIso", "==", countryIso || null)
                    .get();
                if (snapshot.empty) {
                    console.log('No matching curriculums.');
                    const defaultSnapshot = await db.collection(tables_1.Tables.CURRICULUM)
                        .where("countryIso", "==", null)
                        .get();
                    if (!defaultSnapshot.empty) {
                        const defaultCurriculum = defaultSnapshot.docs[0].data();
                        return defaultCurriculum;
                    }
                }
                else if (snapshot.size > 1) {
                    console.log('Curriculum is not unique.');
                    return null;
                }
                else {
                    const curriculum = snapshot.docs[0].data();
                    return curriculum;
                }
            }
            catch (ex) {
                console.error(ex);
            }
            return null;
        };
        this.saveCurriculum = async (curriculum) => {
            let totalWrites = 0;
            try {
                const db = firebase.firestore();
                const chunks = _.chunk(curriculum, this.MAX_BATCH_SIZE);
                for (const chunk of chunks) {
                    const batch = db.batch();
                    for (const curr of chunk) {
                        let fbCurr;
                        if (curr.objectId === null || curr.objectId.length === 0) {
                            fbCurr = db.collection(tables_1.Tables.CURRICULUM).doc();
                            curr.objectId = fbCurr.id;
                        }
                        else {
                            fbCurr = db.collection(tables_1.Tables.CURRICULUM).doc(curr.objectId);
                            curr.updatedAt = new Date();
                        }
                        batch.set(fbCurr, curr, { merge: true });
                        totalWrites++;
                    }
                    console.log("Committing batch: " + totalWrites + " to " + (totalWrites + this.MAX_BATCH_SIZE));
                    // Commit the batch
                    await batch.commit();
                }
            }
            catch (ex) {
                console.log("EX:" + ex);
            }
            return { totalWrites };
        };
        this.getUserByPhone = async (phoneNumber) => {
            if (!this.firebaseApp) {
                return null;
            }
            try {
                const db = this.firebaseApp.firestore();
                const snapshot = await db.collection(tables_1.Tables.USER)
                    .where("phoneNumber", "==", phoneNumber)
                    .get();
                if (snapshot.empty) {
                    console.log('No matching users.');
                    return null;
                }
                if (snapshot.size > 1) {
                    console.log('Phone number is not unique.');
                    return null;
                }
                const userData = snapshot.docs[0].data();
                helpers_1.fixDates(userData);
                return userData;
            }
            catch (ex) {
                console.error(ex);
            }
            return null;
        };
        this.getUserById = async (userId) => {
            try {
                const db = firebase.firestore();
                const snapshot = await db.collection(tables_1.Tables.USER)
                    .doc(userId)
                    .get();
                if (!snapshot.exists) {
                    console.log('No matching users.');
                    return null;
                }
                const userData = snapshot.data();
                helpers_1.fixDates(userData);
                return userData;
            }
            catch (ex) {
                console.error(ex);
            }
            return null;
        };
        this.getAllCourses = async () => {
            try {
                const db = firebase.firestore();
                const snapshot = await db.collection(tables_1.Tables.COURSE)
                    .get();
                if (snapshot.empty) {
                    console.log('No courses.');
                    return null;
                }
                const courseData = snapshot.docs.map(doc => doc.data());
                return courseData;
            }
            catch (ex) {
                console.error(ex);
            }
            return null;
        };
        this.getCourseById = async (objectId) => {
            try {
                const db = firebase.firestore();
                const snapshot = await db.collection(tables_1.Tables.COURSE)
                    .doc(objectId)
                    .get();
                if (!snapshot.exists) {
                    console.log('No courses.');
                    return null;
                }
                const course = snapshot.data();
                return course;
            }
            catch (ex) {
                console.error(ex);
            }
            return null;
        };
        this.saveCourses = async (lessons) => {
            let totalWrites = 0;
            try {
                const db = firebase.firestore();
                const chunks = _.chunk(lessons, this.MAX_BATCH_SIZE);
                for (const chunk of chunks) {
                    const batch = db.batch();
                    for (const course of chunk) {
                        let fbCourse;
                        if (course.objectId === null || course.objectId.length === 0) {
                            fbCourse = db.collection(tables_1.Tables.COURSE).doc();
                            course.createdAt = new Date();
                            course.objectId = fbCourse.id;
                        }
                        else {
                            fbCourse = db.collection(tables_1.Tables.COURSE).doc(course.objectId);
                            course.updatedAt = new Date();
                        }
                        batch.set(fbCourse, course, { merge: true });
                        totalWrites++;
                    }
                    console.log("Committing batch: " + totalWrites + " to " + (totalWrites + this.MAX_BATCH_SIZE));
                    // Commit the batch
                    await batch.commit();
                }
            }
            catch (ex) {
                console.log("EX:" + ex);
            }
            return { totalWrites };
        };
        this.duplicateCourse = async (objectId) => {
            const course = await this.getCourseById(objectId);
            if (course === null)
                return null;
            const db = firebase.firestore();
            const fbCourse = db.collection(tables_1.Tables.COURSE).doc();
            const newObjectId = fbCourse.id;
            course.objectId = newObjectId;
            course.notes = "Copied from Course: " + objectId;
            await fbCourse.set(course);
            return newObjectId;
        };
        this.getAllLessons = async () => {
            try {
                const db = firebase.firestore();
                const snapshot = await db.collection(tables_1.Tables.LESSON)
                    .get();
                if (snapshot.empty) {
                    console.log('No lessons.');
                    return null;
                }
                const lessonData = snapshot.docs.map(doc => doc.data());
                return lessonData;
            }
            catch (ex) {
                console.error(ex);
            }
            return null;
        };
        this.getLeessonsByIds = async (ids) => {
            try {
                const db = firebase.firestore();
                const snapshot = await db.collection(tables_1.Tables.LESSON)
                    .where(firebase.firestore.FieldPath.documentId(), 'in', ids)
                    .get();
                if (snapshot.empty) {
                    console.log('No lessons.');
                    return null;
                }
                const lessonData = snapshot.docs.map(doc => doc.data());
                return lessonData;
            }
            catch (ex) {
                console.error(ex);
            }
            return null;
        };
        this.saveLessons = async (lessons) => {
            let totalWrites = 0;
            try {
                const db = firebase.firestore();
                const chunks = _.chunk(lessons, this.MAX_BATCH_SIZE);
                for (const chunk of chunks) {
                    const batch = db.batch();
                    for (const lesson of chunk) {
                        let fbLesson = null;
                        if (lesson.objectId === null || lesson.objectId.length === 0) {
                            fbLesson = db.collection(tables_1.Tables.LESSON).doc();
                            lesson.createdAt = new Date();
                            lesson.objectId = fbLesson.id;
                        }
                        else {
                            fbLesson = db.collection(tables_1.Tables.LESSON).doc(lesson.objectId);
                            lesson.updatedAt = new Date();
                        }
                        batch.set(fbLesson, lesson, { merge: true });
                        totalWrites++;
                    }
                    console.log("Committing batch: " + totalWrites + " to " + (totalWrites + this.MAX_BATCH_SIZE));
                    // Commit the batch
                    await batch.commit();
                }
            }
            catch (ex) {
                console.log("EX:" + ex);
            }
            return { totalWrites };
        };
        this.getAllPartners = async () => {
            try {
                const db = firebase.firestore();
                const snapshot = await db.collection(tables_1.Tables.PARTNER)
                    .get();
                if (snapshot.empty) {
                    console.log('No partners.');
                    return null;
                }
                const partners = snapshot.docs.map(doc => doc.data());
                return partners;
            }
            catch (ex) {
                console.error(ex);
            }
            return null;
        };
        this.getPartnersByIds = async (ids) => {
            try {
                const db = firebase.firestore();
                const snapshot = await db.collection(tables_1.Tables.PARTNER)
                    .where(firebase.firestore.FieldPath.documentId(), 'in', ids)
                    .get();
                if (snapshot.empty) {
                    console.log('No partners.');
                    return null;
                }
                const partners = snapshot.docs.map(doc => doc.data());
                return partners;
            }
            catch (ex) {
                console.error(ex);
            }
            return null;
        };
        this.savePartners = async (partners) => {
            let totalWrites = 0;
            try {
                const db = firebase.firestore();
                const chunks = _.chunk(partners, this.MAX_BATCH_SIZE);
                for (const chunk of chunks) {
                    const batch = db.batch();
                    for (const partner of chunk) {
                        let fbPartner = null;
                        if (partner.objectId === null || partner.objectId.length === 0) {
                            fbPartner = db.collection(tables_1.Tables.PARTNER).doc();
                            partner.createdAt = new Date();
                            partner.objectId = fbPartner.id;
                        }
                        else {
                            fbPartner = db.collection(tables_1.Tables.PARTNER).doc(partner.objectId);
                            partner.updatedAt = new Date();
                        }
                        batch.set(fbPartner, partner, { merge: true });
                        totalWrites++;
                    }
                    console.log("Committing batch: " + totalWrites + " to " + (totalWrites + this.MAX_BATCH_SIZE));
                    // Commit the batch
                    await batch.commit();
                }
            }
            catch (ex) {
                console.log("EX:" + ex);
            }
            return { totalWrites };
        };
        this.getAllBadges = async () => {
            try {
                const db = firebase.firestore();
                const snapshot = await db.collection(tables_1.Tables.BADGE)
                    .get();
                if (snapshot.empty) {
                    console.log('No badges.');
                    return null;
                }
                const badgeData = snapshot.docs.map(doc => doc.data());
                return badgeData;
            }
            catch (ex) {
                console.error(ex);
            }
            return null;
        };
        this.saveBadges = async (badges) => {
            let totalWrites = 0;
            try {
                const db = firebase.firestore();
                const chunks = _.chunk(badges, this.MAX_BATCH_SIZE);
                for (const chunk of chunks) {
                    const batch = db.batch();
                    for (const badge of chunk) {
                        let fbBadge;
                        if (badge.objectId === null || badge.objectId.length === 0) {
                            fbBadge = db.collection(tables_1.Tables.BADGE).doc();
                            badge.createdAt = new Date();
                            badge.objectId = fbBadge.id;
                        }
                        else {
                            fbBadge = db.collection(tables_1.Tables.BADGE).doc(badge.objectId);
                        }
                        batch.set(fbBadge, badge, { merge: true });
                        totalWrites++;
                    }
                    console.log("Committing batch: " + totalWrites + " to " + (totalWrites + this.MAX_BATCH_SIZE));
                    await batch.commit();
                }
            }
            catch (ex) {
                console.log("EX:" + ex);
            }
            return { totalWrites };
        };
        this.getBadgeById = async (objectId) => {
            try {
                const db = firebase.firestore();
                const snapshot = await db.collection(tables_1.Tables.BADGE)
                    .doc(objectId)
                    .get();
                if (!snapshot.exists) {
                    console.log('No badge with that id.');
                    return null;
                }
                const badge = snapshot.data();
                return badge;
            }
            catch (ex) {
                console.error(ex);
            }
            return null;
        };
        this.saveUsers = async (users) => {
            let totalWrites = 0;
            try {
                const db = firebase.firestore();
                const chunks = _.chunk(users, this.MAX_BATCH_SIZE);
                for (const chunk of chunks) {
                    const batch = db.batch();
                    for (const user of chunk) {
                        let userRef;
                        if (user.objectId === null || user.objectId.length === 0) {
                            userRef = db.collection(tables_1.Tables.USER).doc();
                            user.objectId = userRef.id;
                            user.createdAt = new Date();
                        }
                        else {
                            userRef = db.collection(tables_1.Tables.USER).doc("" + user.objectId);
                            user.updatedAt = new Date();
                        }
                        batch.set(userRef, user, { merge: true });
                        totalWrites++;
                    }
                    console.log("Committing batch: " + totalWrites + " to " + (totalWrites + this.MAX_BATCH_SIZE));
                    await batch.commit();
                }
            }
            catch (ex) {
                console.log("EX:" + ex);
            }
            return { totalWrites };
        };
        this.saveGeolocation = async (userId, geolocation) => {
            try {
                const db = firebase.firestore();
                const userRef = db.collection(tables_1.Tables.USER).doc(userId);
                await userRef.set({
                    geopoint: geolocation
                }, { merge: true });
            }
            catch (ex) {
                console.log("EX:" + ex);
            }
        };
        this.getAllUsers = async () => {
            try {
                const db = firebase.firestore();
                const snapshot = await db.collection(tables_1.Tables.USER)
                    .get();
                if (snapshot.empty) {
                    console.log('No users.');
                    return null;
                }
                const userData = snapshot.docs.map(doc => doc.data());
                userData.map(u => helpers_1.fixDates(u));
                return userData;
            }
            catch (ex) {
                console.error(ex);
            }
            return null;
        };
        this.saveLoanApplication = async (loanApps) => {
            let totalWrites = 0;
            try {
                const db = firebase.firestore();
                const chunks = _.chunk(loanApps, this.MAX_BATCH_SIZE);
                for (const chunk of chunks) {
                    const batch = db.batch();
                    for (const loanApp of chunk) {
                        const loanAppRef = db.collection(tables_1.Tables.LOAN_APPLICATION).doc("" + loanApp.objectId);
                        batch.set(loanAppRef, loanApp, { merge: true });
                        totalWrites++;
                    }
                    console.log("Committing batch: " + totalWrites + " to " + (totalWrites + this.MAX_BATCH_SIZE));
                    await batch.commit();
                }
            }
            catch (ex) {
                console.log("EX:" + ex);
            }
            return { totalWrites };
        };
        this.getAllLoanApplications = async () => {
            try {
                const db = firebase.firestore();
                const snapshot = await db.collection(tables_1.Tables.LOAN_APPLICATION)
                    .get();
                if (snapshot.empty) {
                    console.log('No loan applications.');
                    return null;
                }
                const loanAppData = snapshot.docs.map(doc => doc.data());
                return loanAppData;
            }
            catch (ex) {
                console.error(ex);
            }
            return null;
        };
        this.saveQuizQuestions = async (quizQuestions) => {
            let totalWrites = 0;
            try {
                const db = firebase.firestore();
                const chunks = _.chunk(quizQuestions, this.MAX_BATCH_SIZE);
                for (const chunk of chunks) {
                    const batch = db.batch();
                    for (const question of chunk) {
                        let fbQQ;
                        if (question.objectId === null || question.objectId.length === 0) {
                            fbQQ = db.collection(tables_1.Tables.QUIZ_QUESTION).doc();
                            question.createdAt = new Date();
                            question.objectId = fbQQ.id;
                        }
                        else {
                            fbQQ = db.collection(tables_1.Tables.QUIZ_QUESTION).doc(question.objectId);
                        }
                        batch.set(fbQQ, question, { merge: true });
                        totalWrites++;
                    }
                    console.log("Committing batch: " + totalWrites + " to " + (totalWrites + this.MAX_BATCH_SIZE));
                    await batch.commit();
                }
            }
            catch (ex) {
                console.log("EX:" + ex);
            }
            return { totalWrites };
        };
        this.getAllQuizQuestions = async () => {
            try {
                const db = firebase.firestore();
                const snapshot = await db.collection(tables_1.Tables.QUIZ_QUESTION)
                    .get();
                if (snapshot.empty) {
                    console.log('No quiz questions.');
                    return null;
                }
                const quizQuestionData = snapshot.docs.map(doc => doc.data());
                return quizQuestionData;
            }
            catch (ex) {
                console.error(ex);
            }
            return null;
        };
        this.getQuizQuestionsByIds = async (ids) => {
            try {
                const db = firebase.firestore();
                const chunks = _.chunk(ids, 10);
                const getRequests = chunks.map(chunk => db.collection(tables_1.Tables.QUIZ_QUESTION)
                    .where(firebase.firestore.FieldPath.documentId(), 'in', chunk)
                    .get()
                    .then(snapshot => {
                    if (snapshot.empty) {
                        return [];
                    }
                    return snapshot.docs.map(doc => doc.data());
                }));
                const allResults = await Promise.all(getRequests);
                const data = _.flatten(allResults);
                return data;
            }
            catch (ex) {
                console.error(ex);
            }
            return null;
        };
        this.saveAnswers = async (answers) => {
            let totalWrites = 0;
            try {
                const db = firebase.firestore();
                const chunks = _.chunk(answers, this.MAX_BATCH_SIZE);
                for (const chunk of chunks) {
                    const batch = db.batch();
                    for (const answer of chunk) {
                        let answerRef;
                        if (answer.objectId === null || answer.objectId.length === 0) {
                            answerRef = db.collection(tables_1.Tables.ANSWER).doc();
                            answer.objectId = answerRef.id;
                            answer.createdAt = new Date();
                        }
                        else {
                            answerRef = db.collection(tables_1.Tables.ANSWER).doc("" + answer.objectId);
                            answer.updatedAt = new Date();
                        }
                        batch.set(answerRef, answer, { merge: true });
                        totalWrites++;
                    }
                    console.log("Committing batch: " + totalWrites + " to " + (totalWrites + this.MAX_BATCH_SIZE));
                    await batch.commit();
                }
            }
            catch (ex) {
                console.log("EX:" + ex);
            }
            return { totalWrites };
        };
        this.getAllAnswers = async (limit, offset) => {
            try {
                const db = firebase.firestore();
                const snapshot = await db.collection(tables_1.Tables.ANSWER)
                    .limit(limit)
                    .get();
                if (snapshot.empty) {
                    console.log('No quiz questions.');
                    return null;
                }
                const answerData = snapshot.docs.map(doc => doc.data());
                return answerData;
            }
            catch (ex) {
                console.error(ex);
            }
            return null;
        };
        this.enablePersistance = async () => {
            if (!this.firebaseApp) {
                return;
            }
            await this.firebaseApp.firestore().enablePersistence();
        };
        this.disableNetwork = async () => {
            if (!this.firebaseApp) {
                return;
            }
            await this.firebaseApp.firestore().disableNetwork();
        };
        this.enableNetwork = async () => {
            if (!this.firebaseApp) {
                return;
            }
            await this.firebaseApp.firestore().enableNetwork();
        };
        this.enableAnalyticsCollection = () => {
            if (!this.firebaseApp) {
                return;
            }
            this.firebaseApp.analytics().setAnalyticsCollectionEnabled(true);
        };
        this.logAnalyticEvent = (eventName) => {
            if (!this.firebaseApp) {
                return;
            }
            this.firebaseApp.analytics().logEvent(eventName);
        };
        this.uploadFile = (fileName, blob) => {
            const storageRef = firebase.storage().ref();
            const fileRef = storageRef.child(fileName);
            return fileRef.put(blob);
        };
        this.getDownloadUrl = async (fileName) => {
            const storageRef = firebase.storage().ref();
            const fileRef = storageRef.child(fileName);
            const downloadUrl = await fileRef.getDownloadURL();
            return downloadUrl;
        };
        this.downloadFile = async (fileName, onCompleted, onProgress) => {
            const storageRef = firebase.storage().ref();
            const fileRef = storageRef.child(fileName);
            let blob = undefined;
            const downloadTask = fileRef.getDownloadURL().then(function (url) {
                // `url` is the download URL for 'images/stars.jpg'
                // This can be downloaded directly:
                const xhr = new XMLHttpRequest();
                xhr.responseType = 'blob';
                xhr.onload = function (event) {
                    blob = xhr.response;
                    onCompleted(blob);
                };
                if (onProgress) {
                    xhr.onprogress = function (event) {
                        if (event) {
                            const prcnt = event.loaded / event.total;
                            onProgress(prcnt);
                        }
                    };
                }
                xhr.open('GET', url);
                xhr.send();
            }).catch(function (error) {
                // Handle any errors
            });
            await downloadTask;
        };
        this.getFileSize = async (fileName) => {
            const storageRef = firebase.storage().ref();
            const fileRef = storageRef.child(fileName);
            const metadata = await fileRef.getMetadata();
            if (metadata) {
                return metadata.size;
            }
            return undefined;
        };
        this.deleteFile = async (fileName) => {
            await firebase.storage().ref(fileName).delete();
        };
        this.saveAssets = async (assets) => {
            let totalWrites = 0;
            try {
                const db = firebase.firestore();
                const chunks = _.chunk(assets, this.MAX_BATCH_SIZE);
                for (const chunk of chunks) {
                    const batch = db.batch();
                    for (const asset of chunk) {
                        let assetRef;
                        if (asset.objectId === null || asset.objectId.length === 0) {
                            assetRef = db.collection(tables_1.Tables.ASSET).doc();
                            asset.objectId = assetRef.id;
                        }
                        else {
                            assetRef = db.collection(tables_1.Tables.ASSET).doc("" + asset.objectId);
                        }
                        batch.set(assetRef, asset, { merge: true });
                        totalWrites++;
                    }
                    console.log("Committing batch: " + totalWrites + " to " + (totalWrites + this.MAX_BATCH_SIZE));
                    await batch.commit();
                }
            }
            catch (ex) {
                console.log("EX:" + ex);
            }
            return { totalWrites };
        };
        this.getAllAssets = async (limit) => {
            try {
                const db = firebase.firestore();
                const snapshot = await db.collection(tables_1.Tables.ASSET)
                    .limit(limit)
                    .get();
                if (snapshot.empty) {
                    console.log('No assets.');
                    return null;
                }
                const assets = snapshot.docs.map(doc => doc.data());
                return assets;
            }
            catch (ex) {
                console.error(ex);
            }
            return null;
        };
        this.getAssetsForType = async (limit, type) => {
            try {
                const db = firebase.firestore();
                const snapshot = await db.collection(tables_1.Tables.ASSET)
                    .where("type", "==", type)
                    .limit(limit)
                    .get();
                if (snapshot.empty) {
                    console.log('No assets.');
                    return null;
                }
                const assets = snapshot.docs.map(doc => doc.data());
                return assets;
            }
            catch (ex) {
                console.error(ex);
            }
            return null;
        };
        this.getAssetsBySrc = async (src) => {
            try {
                const db = firebase.firestore();
                const snapshot = await db.collection(tables_1.Tables.ASSET)
                    .where("src", "==", src)
                    .get();
                if (snapshot.empty) {
                    console.log('No assets.');
                    return null;
                }
                const assets = snapshot.docs.map(doc => doc.data());
                return assets.length > 0 ? assets[0] : null;
            }
            catch (ex) {
                console.error(ex);
            }
            return null;
        };
        this.deleteAsset = async (assetId, fileName) => {
            try {
                const db = firebase.firestore();
                await db.collection(tables_1.Tables.ASSET)
                    .doc(assetId)
                    .delete();
                await this.deleteFile(fileName);
            }
            catch (ex) {
                console.error(ex);
            }
            return;
        };
        this.verifyAPIKey = async (apiKey) => {
            if (!apiKey)
                return false;
            try {
                const db = firebase.firestore();
                const snapshot = await db.collection(tables_1.Tables.PARTNER)
                    .where("embedAPIKey", "==", apiKey)
                    .get();
                if (snapshot.empty) {
                    console.log('Invalid API Key.');
                    return false;
                }
                return true;
            }
            catch (ex) {
                console.error(ex);
            }
            return false;
        };
        this.initializeApp();
    }
}
exports.FirebaseWebService = FirebaseWebService;
//# sourceMappingURL=FirebaseWebService.js.map